import React from 'react';
import './ImagesPicker.scss';

import { Tools } from '../../../services'

import { SortableContainer, SortableElement } from 'react-sortable-hoc';

interface ImageProps {
  img: any;
  index: number;
  add?: boolean;
  disabled?: boolean;
  id: string;
}
const ImageItem = SortableElement((props: ImageProps) => props.add ? (
  <div className="picker-picture" key={`pic-${props.index}`} style={{opacity: props.disabled ? 0.4 : 1}} onClick={!props.disabled ? () => Tools.showFilePicker(props.id) : undefined}>
    <div className="picker-add">
      <div><i className="fa fa-plus"></i></div>
      <div>Ajouter une photo</div>
    </div>
  </div>
) : (
  <div className="picker-picture" key={`pic-${props.index}`}>   
    <img src={props.img.url} alt="User" />
  </div>
));

interface ImagesProps {
  items: any[];
  disabled?: boolean;
  id: string;

  removePicture: (index: number) => void;
}
const ImagesList = SortableContainer((props: ImagesProps) => {
  return (
    <div className="images-picker">
      {props.items.map((item, index) => (
        <div key={index} style={{position: 'relative'}}>
          <ImageItem
            id={props.id}
            add={item.add}
            img={item}
            key={index}
            index={index}
            disabled={props.disabled || item.add}
            />
          { index !== props.items.length - 1 && !props.disabled &&
            <div className="picker-close" onClick={() => props.removePicture(index)}><i className="fa fa-close"></i></div>
          }
        </div>
      ))}
    </div>
  )
});

interface Props {
  id?: string;
  title?: string;
  pictures?: any[];
  error?: string;
  disabled?: boolean;

  onChange: (pictures: any[]) => void;
}
const ImagesPicker: React.FC<Props> = (props) => {

  const pictures = props.pictures || []
  const id = props.id || "images-show-picker"

  const onChangePicture = async (evt) => {
    try {
      const url = await Tools.requestSmallImage(evt)
      pictures.push({
        url: url,
        saved: false,
      })
      props.onChange([...pictures])
    } catch (err) {
      alert(err.message)
    }
  }

  const removePicture = (index: number) => {
    const confirm = window.confirm('Souhaitez-vous vraiment supprimer cette photo ?')
    if (!confirm)
      return;
    pictures.splice(index, 1)
    props.onChange([...pictures])
  }

  const onSortEnd = ({oldIndex, newIndex}) => {
    const newSelected: any[] = []
    if (oldIndex < newIndex) {
      // From left to right
      for (let i = 0; i <= newIndex; ++i) {
        if (i !== oldIndex)
          newSelected.push(pictures[i])
      }
      newSelected.push(pictures[oldIndex])
      for (let i = newIndex + 1; i < pictures.length; ++i)
        newSelected.push(pictures[i])
    } else {
      // From right to left
      for (let i = pictures.length - 1; i >= newIndex; --i) {
        if (i !== oldIndex)
          newSelected.push(pictures[i])
      }
      newSelected.push(pictures[oldIndex])
      for (let i = newIndex - 1; i >= 0; --i)
        newSelected.push(pictures[i])
      newSelected.reverse()
    }
    for (let i = 0; i < newSelected.length; ++i) {
      if (newSelected[i]) {
        newSelected[i].featured = i + 1
        newSelected[i].changed = newSelected[i].featured
      }
    }
    props.onChange(newSelected)
  };

  const list = [...pictures, { add: true }]

  return (
    <div className="card">
      <div className="card-header">
        <div className="row spaced-row">
          <h3 className="card-title">{props.title || 'Présentation'}</h3>
          <span className="text-primary" style={{cursor:'pointer', opacity: props.disabled ? 0.4 : 1}} onClick={!props.disabled ? () => Tools.showFilePicker(id) : undefined}>Ajouter une image</span>
        </div>
      </div>
      <div className="card-body">
        { props.error !== undefined &&
          <div className="picture-error error-message">{props.error}</div>
        }
        <div className="images-picker">
          <ImagesList
            id={id}
            axis="x"
            lockAxis="x"
            onSortEnd={onSortEnd}
            items={list}
            disabled={props.disabled}
            removePicture={removePicture}
            />
        </div>

        <input id={id} style={{display: 'none'}} type="file" onChange={onChangePicture} />
      </div>
    </div>
  );
}

export default ImagesPicker